import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { handleCost } from "./handleCost";
export var makeDefaultMenuOrder = function makeDefaultMenuOrder() {
  var productObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var locationId = arguments.length > 1 ? arguments[1] : undefined;
  var ProductId = productObj.ProductId,
      DisplayName = productObj.DisplayName,
      ImageFilePath = productObj.ImageFilePath,
      ListPrice = productObj.ListPrice,
      _productObj$Modifiers = productObj.Modifiers,
      Modifiers = _productObj$Modifiers === void 0 ? {} : _productObj$Modifiers,
      StoreProductId = productObj.StoreProductId,
      ProductChainId = productObj.ProductChainId;
  var returnBody = [];

  if (Modifiers === null) {
    return [];
  } //This key is to flip the order fried is present


  var flipOrder;
  var productModifiers = Modifiers.productModifiers || [];

  try {
    if (productModifiers.length === 1) {
      var radioButtons = Modifiers.productModifiers[0].productModifierOptions;

      for (var i = 0; i < radioButtons.length; i++) {
        var options = handleDefaultOptions(Modifiers.productModifiers, i);
        var label = void 0;
        var cost = options[0].selectedOptions[0].cost;

        if (options[0].selectedOptions[0].optionName.toLowerCase().includes("plate")) {
          label = "2 sides";
        } else if (options[0].selectedOptions[0].optionName.toLowerCase().includes("platter")) {
          label = "3 sides";
        } else if (options[0].selectedOptions[0].optionName.toLowerCase().includes("fried")) {
          label = "Fried";
          flipOrder = true;
        } else if (options[0].selectedOptions[0].optionName.toLowerCase().includes("grill")) {
          label = "Grilled";
          flipOrder = true;
        } else {
          label = options[0].selectedOptions[0].optionName;
        }

        returnBody.push(makeReturnBody(options, ProductId, DisplayName, 1, "", ImageFilePath, handleCost(options, 1, ListPrice), locationId, label, cost, StoreProductId, ProductChainId));
      }
    } else {
      var _options = handleDefaultOptions(Modifiers.productModifiers);

      returnBody.push(makeReturnBody(_options, ProductId, DisplayName, 1, "", ImageFilePath, handleCost(_options, 1, ListPrice), locationId, undefined, undefined, StoreProductId, ProductChainId));
    }
  } catch (e) {
    console.log(e, "e makeDefaultMenuOrder");
  } //If fried/grilled, flip order to ensure fried is first


  if (flipOrder) {
    returnBody = returnBody.reverse();
  }

  return returnBody;
};
export var handleDefaultOptions = function handleDefaultOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var firstLevelAnswer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var array = [];

  for (var i = 0; i < options.length; i++) {
    var _options$i = options[i],
        optionGroupId = _options$i.optionGroupId,
        chainId = _options$i.chainId,
        description = _options$i.description,
        productModifierOptions = _options$i.productModifierOptions;
    var deepOption = productModifierOptions[firstLevelAnswer];
    var selected = {};
    var nested = [];

    if (deepOption.productModifierOptionsGroup !== null) {
      nested = handleDefaultOptions(deepOption.productModifierOptionsGroup);
    }

    selected = {
      optionChainId: deepOption.chainId,
      optionId: deepOption.optionId,
      optionName: deepOption.optionName,
      parentChain: deepOption.parentOptionId,
      cost: deepOption.cost.toFixed(2)
    };
    var newOption = {
      "optionGroupChainId": chainId,
      "optionGroupId": optionGroupId,
      "optionGroupName": description,
      "selectedOptions": [selected]
    };
    array.push.apply(array, [newOption].concat(_toConsumableArray(nested)));
  }

  return array;
};

var makeReturnBody = function makeReturnBody(options, productId, displayName, quantity, instructions, imageUrl, total, storeId) {
  var optionLabel = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : undefined;
  var cost = arguments.length > 9 ? arguments[9] : undefined;
  var StoreProductId = arguments.length > 10 ? arguments[10] : undefined;
  var ProductChainId = arguments.length > 11 ? arguments[11] : undefined;
  return {
    options: options,
    "storeProductId": StoreProductId,
    "productChainId": ProductChainId,
    "displayName": displayName,
    "quantity": quantity,
    "specialInstruction": instructions,
    "recipient": "",
    "imageUrl": imageUrl,
    "total": total,
    "storeId": storeId,
    optionLabel: optionLabel,
    cost: cost
  };
};